import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Helper } from '../helper.service';
import { catchError, Observable } from 'rxjs';
import { DirectoryModel } from '../../models/directory.model';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root',
})
export class DirectoryService {
  options: any;

  constructor(
    private http: HttpClient,
    private helperService: Helper,
  ) {}

  getDirectories(): Observable<any> {
    this.options = { headers: this.helperService.getApiAuthHeader() };
    return this.http.get(environment.directoryServiceEndPoint, this.options).pipe(catchError(this.helperService.handleError));
  }

  saveDirectory(newDirectory: DirectoryModel): Observable<any> {
    this.options = { headers: this.helperService.getApiAuthHeader() };
    return this.http.post(environment.directoryServiceEndPoint, JSON.stringify(newDirectory), this.options).pipe(catchError(this.helperService.handleError));
  }

  updateDirectory(newDirectory: DirectoryModel): Observable<any> {
    this.options = { headers: this.helperService.getApiAuthHeader() };
    return this.http.patch(environment.directoryServiceEndPoint, JSON.stringify(newDirectory), this.options).pipe(catchError(this.helperService.handleError));
  }
}
